import React, { useCallback, useEffect, useState } from "react";

export interface AsyncComponentProps { }

export interface AsyncComponentState<P, S> {
    Component: React.Component<P, S>;
}

/**
 * A wrapper to return a component asynchronously.
 *
 * Help from https://github.com/mozilla-neutrino/react-router-starter/blob/master/src/components/asyncComponent.js
 * and https://github.com/mesteche/react-redux-starter-kit/blob/react-router-v4/src/containers/AsyncComponent.js
 * @export
 * @param {() => Promise<React.Component<P, S>>} getComponent
 * @returns
 */
export function asyncComponent<P, S>(getComponent: () => Promise<React.Component<P, S>>): React.FC<P> {
    return useCallback((props: P) => {
        const [component, setComponent] = useState<{ Component: React.Component<P, S> }>();

        useEffect(() => {
            let disposed = false;
            getComponent().then(comp => {
                if (!disposed) {
                    setComponent({
                        Component: comp
                    });
                }
            });

            return () => {
                disposed = true;
            };
        }, []);

        const Component = component?.Component as any;
        if (Component) {
            return <Component {...props} />;
        }

        return <></>;
    }, [getComponent]);
}
